export default __webpack_public_path__ + "static/media/Hot_Mop_planters.094be519.jpg";